// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__295bj","item":"PaymentsMobile_item__Io7ma","label":"PaymentsMobile_label__3V2YF","amount":"PaymentsMobile_amount__3MhuS"};